import { createKey } from '@/lib/stageUtil'
import { useStageStore } from '@/stores/stage'
import type { ProjectMutator } from '@/lib/entity/project'
import { DataBase } from '@/lib/kysely'

async function getProjectWithUsers(projectId: string) {
  // 編集前のデータが権限チェック対象
  const result = await DataBase.selectFrom('project_to_user')
    .select(['user_id'])
    .where('project_to_user.project_id', '=', projectId)
    .where('project_to_user.deleted_at', 'is', null)
    .execute()

  const userIds = result.map((pu: { user_id: string }) => pu.user_id)

  return {
    id: projectId,
    userIds
  }
}

export async function getProjectWithUsersWithStage(projectId: string | undefined) {
  if (typeof projectId !== 'string' || projectId.trim().length === 0) {
    throw new Error('Invalid projectId: must be a non-empty string')
  }

  const stage = useStageStore()
  const key = createKey('project', projectId)
  const stagedProject = stage.get<ProjectMutator>(key)

  if (stagedProject && stagedProject.isNewEntity()) {
    // stagedに新しいprojectがある場合、新規プロジェクト作成の操作を行って作ったデータ
    // そのプロジェクトは、ログインユーザーがコミットするまでは、無条件でログインユーザーに編集権限があるとみなす。
    return {
      id: projectId,
      isStaged: true
    }
  }

  return getProjectWithUsers(projectId)
}
